import styled from '@emotion/styled';
import {ReactComponent as InformationSVG} from '../../../assets/icons/ic_exclamation.svg';

export const CardErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({theme}) => theme.gap.desktop.xs};
  padding: ${({theme}) => theme.padding.desktop.md};
`;

export const CardErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.md};
  padding: ${({theme}) => theme.padding.desktop.xl};

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    gap: ${({theme}) => theme.gap.desktop.xs};
    padding: ${({theme}) => theme.padding.desktop.lg};
  }
`;

export const CardErrorContentTop = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.sm};
`;

export const IconInformation = styled(InformationSVG)`
  width: ${({theme}) => theme.icon.size.md};
  height: ${({theme}) => theme.icon.size.md};
  fill: ${({theme}) => theme.color.neutral.grey_900};
`;
